import './style.scss'
import { FC, memo, Suspense, useEffect } from 'react'
import * as HomeApi from '@/api/home'
import { eventTracking } from '@/libs/util'
import AvatarCreate from './components/AvatarCreate'
import Carousel from './components/Carousel'
import QuicklyCreate from './components/QuicklyCreate'
import { HomeStore } from './home-state'

const HomePage: FC = () => {
  useEffect(() => {
    getData()
  }, [])

  const getData = async () => {
    const bd_vid = sessionStorage.getItem('bd_vid')
    const msclkid = sessionStorage.getItem('msclkid')
    const keywords = sessionStorage.getItem('keywords')
    const utm = sessionStorage.getItem('utm')
    let ad_type = ''

    if (bd_vid) {
      ad_type = 'BAIDU_SEM'
    } else if (msclkid) {
      ad_type = 'BING_SEM'
    }

    const res = await HomeApi.getHomeInfo({
      ad_type,
      keywords,
      utm
    })
    HomeStore.banners = res.heroareas || []
    HomeStore.scenes = res.scenes || []
    HomeStore.scene_title = res.scene_title
    HomeStore.shortcuts = res.shortcuts || []
    HomeStore.shortcut_title = res.shortcut_title
    HomeStore.strategy_id = res.id
    eventTracking('Homepage', {
      home: {
        id: res.id,
        heroareas: res.heroareas?.map((d: any) => +d.id),
        scenes: res.scenes?.map((d: any) => +d.id),
        shortcuts: res.shortcuts?.map((d: any) => +d.id)
      }
    })
  }

  return (
    <Suspense>
      <div className="page-common page-homepage">
        <div className="common-wrapper">
          <div className="wrapper-box">
            <Carousel />
            <QuicklyCreate />
            <AvatarCreate />
          </div>
        </div>
      </div>
    </Suspense>
  )
}

export default memo(HomePage)
